import { ActionButton, ActionButtonInverted } from 'components/button/button.styled'
import { ButtonContainer, WrapperRow } from 'components/ticket/ticket.style'

interface BulkTicketControlsProps {
    activeLoadingKey: string | null
    setActiveLoadingKey: (key: string | null) => void
    handlePrintAllTickets: () => Promise<void>
    handleDownloadAllTickets: () => Promise<void>
    areAllTicketsSold?: boolean
}

export const BulkTicketControls = ({
    activeLoadingKey,
    setActiveLoadingKey,
    handlePrintAllTickets,
    handleDownloadAllTickets,
    areAllTicketsSold,
}: BulkTicketControlsProps) => {
    const isAnyLoading = activeLoadingKey !== null

    const isButtonDisabled = (key: string) => isAnyLoading && activeLoadingKey !== key

    const showButtons = areAllTicketsSold === undefined || areAllTicketsSold

    return (
        <WrapperRow>
            <ButtonContainer>
                {showButtons ? (
                    <>
                        <ActionButton
                            label={activeLoadingKey === 'bulk-download' ? 'Összes letöltése...' : 'Összes letöltése'}
                            onClick={async () => {
                                setActiveLoadingKey('bulk-download')
                                await handleDownloadAllTickets()
                                setActiveLoadingKey(null)
                            }}
                            disabled={isButtonDisabled('bulk-download')}
                        />
                        <ActionButtonInverted
                            label={activeLoadingKey === 'bulk-print' ? 'Összes nyomtatása...' : 'Összes nyomtatása'}
                            onClick={async () => {
                                setActiveLoadingKey('bulk-print')
                                await handlePrintAllTickets()
                                setActiveLoadingKey(null)
                            }}
                            disabled={isButtonDisabled('bulk-print')}
                        />
                    </>
                ) : (
                    <span>A fizetés folyamatban</span>
                )}
            </ButtonContainer>
        </WrapperRow>
    )
}
